import { useEffect } from 'react';
import { usersApi } from '../api/users.api';
import { STATUS } from '../../../interaces/selects.interfaces';
import { useRoles } from '../../roles/hooks/useRoles';
import { formatOptionsForSelect } from '../../../services/helpers';
import { useDataTable } from '../../../hooks/useDataTable';
import { ENUM_MODULES } from '../../../interaces/enums/enums.interface';

export const useUsers = (module=ENUM_MODULES.USERS) => {
  const table = useDataTable(usersApi);
  const { setDataFilters,names } = table;
  useEffect(() => {
    if(module!=ENUM_MODULES.USERS)return
    setDataFilters([
      {
        filter: 'status',
        value_filter: '',
        data: STATUS,
        width: 'col-span-3 max-[768px]:col-span-12',
      },
      {
        filter: 'role',
        value_filter: '',
        data: formatOptionsForSelect(names, 'name', 'name', 'Elegir role'),
        width: 'col-span-3 max-[768px]:col-span-12',
      },
    ]);
  }, [names,setDataFilters]);

  return {
    ...table,
  };
};
